import { Bob } from "../stores/Bob";
import { makeSpreadsheetLine } from "./spreadSheet";
import { makeTransactionsListLine } from "./transactionsList";
import { makeTransactionsPage } from "./transactionViewer";
import { CurrencySnapshot } from "./types";

export interface PlatformCredit {
  created_at: number;
  uuid: string;
  amount_in_satoshis: number;
  currency_snapshot: CurrencySnapshot;
  user_facing_description: string | null;
}

const getPlatformCreditDisplayData = (platformCreditData: PlatformCredit) => {
  const isCredit = platformCreditData.amount_in_satoshis >= 0;

  return {
    amountSatoshis: Math.abs(platformCreditData.amount_in_satoshis),
    isCredit,
    label: isCredit ? "Platform credit" : "Platform debit",
    status: isCredit ? "Credited" : "Debited",
  };
};

export const makeSpreadsheetLineForPlatformCredit = (
  platformCreditData: PlatformCredit,
  bob: Bob,
) => {
  const displayData = getPlatformCreditDisplayData(platformCreditData);

  return makeSpreadsheetLine({
    type: displayData.label.toLowerCase(),
    status: displayData.status,
    uuid: platformCreditData.uuid,
    createdAtInteger: platformCreditData.created_at,
    currencySnapshot: platformCreditData.currency_snapshot,
    currency: bob.currencyCode,
    amountSatoshis: displayData.amountSatoshis,
    isCredit: displayData.isCredit,
    comment: platformCreditData.user_facing_description || null,
    payRequest: null,
    routingFeeSatoshis: null,
    platformFeeSatoshis: null,
    lightningAddress: null,
  });
};

export const makeTransactionsListLineForPlatformCredit = (
  platformCreditData: PlatformCredit,
  bob: Bob,
) => {
  const displayData = getPlatformCreditDisplayData(platformCreditData);

  return makeTransactionsListLine({
    amountSatoshis: displayData.amountSatoshis,
    label: displayData.label,
    createdAtInteger: platformCreditData.created_at,
    comment: platformCreditData.user_facing_description || null,
    currencySnapshot: platformCreditData.currency_snapshot,
    currency: bob.currencyCode,
    isCredit: displayData.isCredit,
    modelName: "PlatformCredit",
    uuid: platformCreditData.uuid,
    isConfirmed: true, // Platform adjustments are always confirmed
    lightningAddress: null,
    zapName: null,
    zapPictureUrl: null,
  });
};

export const makeTransactionPageDataForPlatformCredit = (
  platformCredit: PlatformCredit,
  bob: Bob,
) => {
  const displayData = getPlatformCreditDisplayData(platformCredit);

  return makeTransactionsPage({
    header: displayData.label,
    uuid: platformCredit.uuid,
    createdAtInteger: platformCredit.created_at,
    amountSatoshis: displayData.amountSatoshis,
    routingFeeSatoshis: null,
    platformFeeSatoshis: null,
    currencySnapshot: platformCredit.currency_snapshot,
    currency: bob.currencyCode,
    isCredit: displayData.isCredit,
    comment: platformCredit.user_facing_description || null,
    payRequest: null,
    lightningAddress: null,
  });
};
